module.exports = __webpack_public_path__ + "static/media/background-logo-main.c6682261.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/background-logo-main.svg
// module id = 3090
// module chunks = 1